module.exports = __webpack_public_path__ + "img/068_thumbnail.8998aacd.jpg";